export default __webpack_public_path__ + "static/media/treatment_next.43b88cf0.png";